import { jsx as o } from "react/jsx-runtime";
import { X as p } from "../../vendor--aJiswR_.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as n } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index48.css';const r = "_input_1h873_1", i = {
  input: r
};
function f(t) {
  return /* @__PURE__ */ o(p, { ...n(t), className: i.input, "data-component": "Input" });
}
export {
  f as Input
};
//# sourceMappingURL=index.js.map
